import React, { Component } from "react";
import MetricsContent from '../FunctionComponents/Metrics/MetricsContent';

class Metrics extends Component {
  render() {
    return (
      <div>
        < MetricsContent />
      </div>
    );
  }
}

export default Metrics;
